/*eslint-disable */
const $ = window.jQuery = require('jquery');

import loader from '@/components/common/component-small-loader';
import {
  mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'notes-of-patient',
  components: {
    loader
  },
  props: ['notesOfPateintId'],
  data () {
    return {
      listedOfNotesPatient:null,
      listedOfNotesPatientResults:[],
      notesOfPatientFirstStep:true,
      notesOfPatientSecondStep:false,
      notesOfPatientThirdStep:false,
      notesOfPatientFourStep:false,
      createNotesTitle:'',
      createNotesData:'',
      updateNotesDataId:'',
      updateNotesTitle:'',
      updateNotesData:'',
      removePopupState:false
    }
  },
  computed: {
  },
  mounted () {
    this.getNotesListedOfPatientMethod(this.notesOfPateintId)
  },
  methods: {
    getNotesListedOfPatientMethod(id){
      if(!id) return;
      this.$store.dispatch('getNotesListOfPatientMethod', {id:id}).then((res)=>{
        this.listedOfNotesPatient =  res.data.data
        this.listedOfNotesPatientResults = res.data.data.results
      })
    },
    createdNotesDataSectionEnabled(){
      this.notesOfPatientFirstStep = false
      this.notesOfPatientSecondStep = true
    },
    goToFistStepFromSecond(){
      this.notesOfPatientFirstStep = true
      this.notesOfPatientSecondStep = false
    },
    goToFistStepFromThird(){
      this.notesOfPatientFirstStep = true
      this.notesOfPatientThirdStep = false
    },
    savedNotesDataMethod(){
      if(this.createNotesData.length > 0){
        let data = {
          data:this.createNotesData,
          title:this.createNotesTitle,
          patient_id:this.notesOfPateintId
        }
        this.$store.dispatch('createNotesOfPatientMethod', data).then((res)=>{
          this.getNotesListedOfPatientMethod(this.notesOfPateintId)
          this.createNotesData = ''
          this.createNotesTitle = ''
          this.goToFistStepFromSecond()
        }).catch((err)=>{
          
        })
      }else{
        this.goToFistStepFromSecond()
      }
    },
    updateNotesDataMethod(data){
      this.updateNotesDataId = data.id
      this.updateNotesTitle = data.title
      this.updateNotesData = data.data
      this.notesOfPatientFirstStep = false
      this.notesOfPatientThirdStep = true
    },
    updatedPatientNotesDataMethod(){
      let data = {
        data:this.updateNotesData,
        title:this.updateNotesTitle
      }
      this.$store.dispatch('updateNotesDataOfPatientMethod',{data:{data:data,id:this.updateNotesDataId }}).then((res)=>{
        this.getNotesListedOfPatientMethod(this.notesOfPateintId)
      }).catch((err)=>{})
    },
    removeNotesOfPatientPopupOpenMethod(){
      this.removePopupState =  true
      document.body.classList.add('body_right_scroll_remove')
    },
    removeNotesOfPatientPopupClosedMethod(){
      this.removePopupState =  false
      document.body.classList.remove('body_right_scroll_remove')
    },
    removeNotesFromListedMethod(){
      this.$store.dispatch('removeNotesOfPatientMethod', {id:this.updateNotesDataId}).then((res)=>{
        toast.success(res.data.msg);
        this.goToFistStepFromThird()
        this.getNotesListedOfPatientMethod(this.notesOfPateintId)
        this.removeNotesOfPatientPopupClosedMethod()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
  },
  watch:{
    notesOfPateintId(new_val, old_val){
      this.getNotesListedOfPatientMethod(new_val)
    }
  }
}